const config = {
  // API基础URL
  apiBaseUrl: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3000/api',
  
  // 应用名称
  appName: '微信公众号管理系统',
  
  // 开发环境配置
  development: {
    apiBaseUrl: 'http://localhost:3000/api'
  },
  
  // 生产环境配置
  production: {
    apiBaseUrl: '/api'
  }
}

export default config 